module.exports = __webpack_public_path__ + "static/28d-card-bg-01efb82346885ca280d6b62fa3d19688.png";